import { createSlice } from "@reduxjs/toolkit";
import { PAGELENGTH } from "components/common/ListLayout";
import Api from "services/api";

export const initialState = {
  courtTypes: [],
  error: null,
  loader: false,
  total: 0,
  is_more: false,
  current_page: 1,
  per_page: PAGELENGTH,
  last_page: 1,
};

export const courtTypeSlice = createSlice({
  name: "courtTypes",
  initialState,
  reducers: {
    setCourtTypes: (state, { payload }) => {
      state.courtTypes = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
    setLoader: (state, { payload }) => {
      state.loader = payload;
    },
  },
});

// --------------------------
// Thunks
// --------------------------

// ✅ Fetch all court types (Read Only)
export const fetchCourtTypes =
  (page = 1, params = {}, disableLoader = false, Async = false) =>
  async (dispatch) => {
    if (!disableLoader) dispatch(setLoader(true));

    try {
      const result = await Api.fetchCourtTypes(page, params);
      if (result.status >= 200 && result.status < 300) {
        if (Async) {
          return result?.data?.data;
        } else {
          dispatch(setCourtTypes(result.data));
        }
      } else if (result?.status === 422) {
        if (Async) {
          return [];
        } else {
          dispatch(setError(result.data));
        }
      }
    } catch (error) {
      console.error("CourtType fetch error:", error);
      dispatch(setError(error.response?.data || error.message));
    }

    if (!disableLoader) dispatch(setLoader(false));
  };

// --------------------------
// Exports
// --------------------------
export const { setCourtTypes, setLoader, setError } = courtTypeSlice.actions;

export default courtTypeSlice.reducer;

// Selector
export const courtTypesSelector = (state) => state.courtTypes;
